/**
 *
 * @description Generate a random ID of a specified length with an optional prefix
 * @param {string} prefix - The prefix to be added to the generated ID. Default is an empty string.
 * @param {number} length - The length of the ID to be generated. Default is 6.
 * @returns {string} The generated ID.
 * @example
 * generateID("user_", 10) // -->  "user_a023abc4f6"
 */
function generateID(prefix = "", length = 6) {
  let prefix_ = prefix;

  if (typeof prefix !== "string") {
    prefix_ = String(prefix);
  }

  if (length < 1) {
    throw new Error("generateID error: Length must be a positive integer");
  }

  const bytesArray = new Uint8Array(length);
  crypto.getRandomValues(bytesArray);

  const id = Array.from(bytesArray, (byte) => byte.toString(16).padStart(2, "0")).join("");

  return `${prefix_}${id}`;
}

export default generateID;
